"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wait = void 0;

var Wait = function Wait(_ref) {
  var until = _ref.until,
      launch = _ref.launch,
      lounge = _ref.lounge,
      children = _ref.children;

  if (!until()) {
    launch();
    return lounge;
  }

  return children;
};

exports.Wait = Wait;